import * as React from 'react'
import { SVGProps } from 'react'

const SvgDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4ZM1.333 16C1.333 7.9 7.9 1.333 16 1.333S30.667 7.9 30.667 16 24.1 30.667 16 30.667 1.333 24.1 1.333 16ZM16 9.333c.736 0 1.333.597 1.333 1.334v7.447l3.058-3.057a1.333 1.333 0 1 1 1.885 1.886l-5.333 5.333c-.52.52-1.365.52-1.886 0l-5.333-5.333a1.333 1.333 0 1 1 1.886-1.886l3.057 3.057v-7.447c0-.737.597-1.334 1.333-1.334Z"
      fill="currentColor"
    />
  </svg>
)
export default SvgDownload
